import { baseUrl } from "../config/apiConfig";
import AI_PDF_CONST from "../util/PdfAiConst";
import { getDataFromLocalStorage } from "../util/localStorage";

export const generateResponse = async ({
  id,
  query,
  //openDocument,
  setChatHistory,
  scrollToBottom,
  setLoading,
  setErrorMessage,
  setIsMessageShow,
}) => {
  if (!query.trim()) {
    console.error("Query is empty.");
    return;
  }

  const newChat = { question: query, response: "", isLoading: true };
  setChatHistory((prev) => [...prev, newChat]); // Add the new question to the chat history
  setLoading(true);
  setTimeout(scrollToBottom, 0); // Ensure scrolling happens after DOM update

  const token = getDataFromLocalStorage("token");

  if (!token) {
    console.error("Token not found. Please log in first.");
    setLoading(false);
    return;
  }

  // if (!openDocument) {
  //   console.error("Document reference is missing.");
  //   setLoading(false);
  //   return;
  // }

  try {
    const response = await fetch(
      `${baseUrl + AI_PDF_CONST.API_ENDPOINT.GPT_QUERY}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          doc_id: id,
          query,
        }),
      }
    );

    if (!response.body) {
      console.error("No response body received.");
      setLoading(false);
      return;
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");

    let done = false;

    while (!done) {
      const { value, done: readerDone } = await reader.read();
      done = readerDone;
      if (value) {
        const chunk = decoder.decode(value);

        // Update the latest chat's response in the state
        setChatHistory((prev) => {
          const updated = [...prev];

          const lastIndex = updated.length - 1;
          if (lastIndex >= 0) {
            let currentResponse = updated[lastIndex].response || "";

            if (
              chunk.endsWith("\n") ||
              chunk.endsWith("!") ||
              chunk.endsWith("?")
            ) {
              currentResponse += chunk + "<br>";
            } else {
              currentResponse += chunk;
            }

            updated[lastIndex] = {
              ...updated[lastIndex],
              response: currentResponse,
            };
          }

          return updated;
        });

        setTimeout(scrollToBottom, 0);
      }
    }
  } catch (error) {
    console.error("Error streaming response:", error);
    setErrorMessage(error.message);
    setIsMessageShow(true);
  } finally {
    setLoading(false);

    setChatHistory((prev) => {
      const updated = [...prev];
      updated[updated.length - 1].isLoading = false;
      return updated;
    });
    setTimeout(scrollToBottom, 0);
  }
};

export const fetchChatHistory = async (
  id,
  setErrorMessage,
  setIsMessageShow
) => {
  try {
    const token = getDataFromLocalStorage("token");

    if (!token) {
      console.error("Token not found. Please log in first.");
      return null; // Return null if no token
    }

    const response = await fetch(
      `${baseUrl + AI_PDF_CONST.API_ENDPOINT.GPT_HISTORY}/${id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch chat history: ${response.statusText}`);
    }

    const data = await response.json();

    // Correct handling of response format
    if (data && Array.isArray(data.data)) {
      return data.data.map((item) => ({
        question: item.q_a.q, // Extract the question
        //response: item.q_a.a, // Extract the response
        response: formatResponse(item.q_a.a), // Format response
      }));
    } else {
      console.error("Unexpected response format:", data);
      return null;
    }
  } catch (err) {
    console.error("Error fetching chat history:", err.message);
    setErrorMessage(err.message); // Update error state
    setIsMessageShow(true); // Show the error popup
    return null;
  }
};

const formatResponse = (response) => {
  if (!response) return "";
  return response
    .split("\n") // Split only on newlines
    .map((line) => line.trim()) // Trim whitespace from each line
    .filter((line) => line) // Remove empty lines
    .join("<br>"); // Join lines with <br> for HTML formatting
};
